import { Project, Workflow } from 'components/framework/models';

export const getProjectQuery = async (projectId: RecordId) => {
  const scope = Project.select('id').merge({
    epicWorkflow: Workflow.select('id').merge({
      workflowStatuses: ['id', 'name'],
    }),
    featureWorkflow: Workflow.select('id').merge({
      workflowStatuses: ['id', 'name'],
    }),
    requirementWorkflow: Workflow.select('id').merge({
      workflowStatuses: ['id', 'name'],
    }),
    initiativeWorkflow: Workflow.select('id').merge({
      workflowStatuses: ['id', 'name'],
    }),
    strategicImperativeWorkflow: Workflow.select('id').merge({
      workflowStatuses: ['id', 'name'],
    }),
    releaseWorkflow: Workflow.select('id').merge({
      workflowStatuses: ['id', 'name'],
    }),
    ideaWorkflow: Workflow.select('id').merge({
      workflowStatuses: ['id', 'name'],
    }),
    developTeams: Project.select('id').merge({
      featureWorkflow: Workflow.select('id').merge({
        workflowStatuses: ['id', 'name'],
      }),
      epicWorkflow: Workflow.select('id').merge({
        workflowStatuses: ['id', 'name'],
      }),
    }),
  });

  const info = await scope.find(projectId);

  return info;
};

export const getTeamsQuery = async () => {
  return Project.select('id', 'name')
    .merge({
      epicWorkflow: Workflow.select('id').merge({
        workflowStatuses: ['id', 'name'],
      }),
      featureWorkflow: Workflow.select('id').merge({
        workflowStatuses: ['id', 'name'],
      }),
    })
    .where({ teams: true })
    .all();
};
